import SVG from '@/assets/svg/SVG';
import Link from '@/components/Link';
import RetryStackPopover from '@/components/RetryStackPopover';
import clearFilters from '@/screens/jobs/lib/clearFilters';
import { Fragment } from 'react';
import IconV2 from './IconV2';

const ScreenBreadcrumbV2 = ({ stack: breadcrumbStack = [], hoverEffect = false, className = '' }) => {
  return (
    <div className={`comp-screen-breadcrumb-v2 ${className}`.trim()}>
      <div className={'heading'}>
        {breadcrumbStack.map((stackItem, index) => (
          <Fragment key={index}>
            {index > 0 && <span className={'divider'}>›</span>}
            {stackItem.icon && (
              <IconV2 className={stackItem?.className}>
                <SVG icon={stackItem.icon} />
              </IconV2>
            )}
            {stackItem.icons &&
              stackItem.icons.map((n, index) => (
                <IconV2 key={index} className={stackItem?.className} title={n?.title}>
                  <SVG icon={n?.icon} />
                </IconV2>
              ))}
            {index < breadcrumbStack.length - 1 &&
              stackItem.label &&
              (stackItem.onClick && !stackItem.route ? (
                <span className={`back ${hoverEffect ? 'breadcrumb-hover' : ''} ${stackItem?.className || ''}`.trim()} onClick={stackItem?.onClick} data-title={stackItem.tooltip}>
                  {stackItem.label}
                </span>
              ) : stackItem.retryStack && Array.isArray(stackItem.retryStack) && stackItem.retryStack.length > 0 ? (
                <RetryStackPopover retryStack={stackItem.retryStack}>
                  <span className={`back ${hoverEffect ? 'breadcrumb-hover' : ''} ${stackItem?.className || ''}`.trim()} onClick={() => clearFilters()} data-title={stackItem.tooltip}>
                    {stackItem.label}
                  </span>
                </RetryStackPopover>
              ) : (
                <Link to={stackItem.route} onClick={stackItem.onClick}>
                  <span className={`back ${hoverEffect ? 'breadcrumb-hover' : ''} ${stackItem?.className || ''}`.trim()} onClick={() => clearFilters()} data-title={stackItem.tooltip}>
                    {stackItem.label}
                  </span>
                </Link>
              ))}
            {index >= breadcrumbStack.length - 1 && stackItem.label && (
              <span className={`text ${hoverEffect ? 'breadcrumb-hover' : ''} ${stackItem?.className || ''}`.trim()} onClick={stackItem?.onClick} data-title={stackItem.tooltip || stackItem.label}>
                {stackItem.label}
              </span>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default ScreenBreadcrumbV2;
